/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/accounting/service.proto" (package "rd.api.accounting", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { JournalEntry_Type } from "../../accounting/models_pb";
import { JournalEntry } from "../../accounting/models_pb";
import { OrderShipment } from "../../txn/models_pb";
import { Customer } from "../../customer/models_pb";
import { Location } from "../../company/models_pb";
import { Vendor } from "../../vendors/models_pb";
import { ExternalTransaction } from "../../accounting/models_pb";
import { ExternalTransaction_PaymentMethod } from "../../accounting/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { ExternalTransaction_Type } from "../../accounting/models_pb";
import { Money } from "../../proto/money/models_pb";
import { ExternalAccount } from "../../accounting/models_pb";
import { ExternalAccount_Type } from "../../accounting/models_pb";
import { Mapping } from "../../coa/models_pb";
import { Summary } from "../../bubv2/models_pb";
import { Account } from "../../coa/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
import { Account_Type } from "../../coa/models_pb";
/**
 * Account
 *
 * @generated from protobuf message rd.api.accounting.CreateAccountReq
 */
export interface CreateAccountReq {
    /**
     * @generated from protobuf field: int32 number = 1
     */
    number: number;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: rd.coa.Account.Type type = 4
     */
    type: Account_Type;
}
/**
 * @generated from protobuf message rd.api.accounting.CreateAccountRes
 */
export interface CreateAccountRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.ListAccountsReq
 */
export interface ListAccountsReq {
    /**
     * @generated from protobuf field: repeated rd.coa.Account.Type account_types = 2
     */
    accountTypes: Account_Type[];
    /**
     * @generated from protobuf field: bool filter_active = 3
     */
    filterActive: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.ListAccountsRes
 */
export interface ListAccountsRes {
    /**
     * @generated from protobuf field: repeated rd.coa.Account accounts = 3
     */
    accounts: Account[];
}
/**
 * @generated from protobuf message rd.api.accounting.GetAccountReq
 */
export interface GetAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GetAccountRes
 */
export interface GetAccountRes {
    /**
     * @generated from protobuf field: rd.coa.Account account = 1
     */
    account?: Account;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateAccountReq
 */
export interface UpdateAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: int32 number = 2
     */
    number: number;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
    /**
     * @generated from protobuf field: rd.coa.Account.Type type = 5
     */
    type: Account_Type;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateAccountRes
 */
export interface UpdateAccountRes {
}
/**
 * @generated from protobuf message rd.api.accounting.DeactivateAccountReq
 */
export interface DeactivateAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.DeactivateAccountRes
 */
export interface DeactivateAccountRes {
}
/**
 * @generated from protobuf message rd.api.accounting.ReactivateAccountReq
 */
export interface ReactivateAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.ReactivateAccountRes
 */
export interface ReactivateAccountRes {
}
/**
 * @generated from protobuf message rd.api.accounting.BulkUpsertAccountsReq
 */
export interface BulkUpsertAccountsReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.BulkUpsertAccountsRes
 */
export interface BulkUpsertAccountsRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * Mapping
 *
 * @generated from protobuf message rd.api.accounting.ListMappingsReq
 */
export interface ListMappingsReq {
    /**
     * @generated from protobuf field: bool filter_active = 1
     */
    filterActive: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.ListMappingsRes
 */
export interface ListMappingsRes {
    /**
     * @generated from protobuf field: repeated rd.coa.Mapping mappings = 1
     */
    mappings: Mapping[];
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateMappingAccountReq
 */
export interface UpdateMappingAccountReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID mapping_ids = 1
     */
    mappingIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 2
     */
    accountId?: UUID;
    /**
     * @generated from protobuf field: bool should_be_separate_row = 3
     */
    shouldBeSeparateRow: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateMappingAccountRes
 */
export interface UpdateMappingAccountRes {
}
/**
 * @generated from protobuf message rd.api.accounting.BulkUpsertMappingsReq
 */
export interface BulkUpsertMappingsReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.BulkUpsertMappingsRes
 */
export interface BulkUpsertMappingsRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * Income Statement
 *
 * @generated from protobuf message rd.api.accounting.GenerateIncomeStatementReq
 */
export interface GenerateIncomeStatementReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateIncomeStatementRes
 */
export interface GenerateIncomeStatementRes {
}
/**
 * Balance Sheet
 *
 * @generated from protobuf message rd.api.accounting.GenerateBalanceSheetReq
 */
export interface GenerateBalanceSheetReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateBalanceSheetRes
 */
export interface GenerateBalanceSheetRes {
}
/**
 * External Accounts
 *
 * @generated from protobuf message rd.api.accounting.CreateExternalAccountReq
 */
export interface CreateExternalAccountReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.accounting.ExternalAccount.Type type = 2
     */
    type: ExternalAccount_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID coa_account_id = 3
     */
    coaAccountId?: UUID;
    /**
     * @generated from protobuf field: string last_4 = 4
     */
    last4: string;
}
/**
 * @generated from protobuf message rd.api.accounting.CreateExternalAccountRes
 */
export interface CreateExternalAccountRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateExternalAccountReq
 */
export interface UpdateExternalAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.accounting.ExternalAccount.Type type = 3
     */
    type: ExternalAccount_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID coa_account_id = 4
     */
    coaAccountId?: UUID;
    /**
     * @generated from protobuf field: string last_4 = 5
     */
    last4: string;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateExternalAccountRes
 */
export interface UpdateExternalAccountRes {
}
/**
 * @generated from protobuf message rd.api.accounting.DeactivateExternalAccountReq
 */
export interface DeactivateExternalAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.DeactivateExternalAccountRes
 */
export interface DeactivateExternalAccountRes {
}
/**
 * @generated from protobuf message rd.api.accounting.ListExternalAccountsReq
 */
export interface ListExternalAccountsReq {
    /**
     * @generated from protobuf field: bool active_only = 1
     */
    activeOnly: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.ListExternalAccountsRes
 */
export interface ListExternalAccountsRes {
    /**
     * @generated from protobuf field: repeated rd.accounting.ExternalAccount accounts = 1
     */
    accounts: ExternalAccount[];
}
/**
 * External Transactions
 *
 * @generated from protobuf message rd.api.accounting.GetExternalAccountBalanceReq
 */
export interface GetExternalAccountBalanceReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 1
     */
    externalAccountId?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GetExternalAccountBalanceRes
 */
export interface GetExternalAccountBalanceRes {
    /**
     * @generated from protobuf field: rd.proto.money.Money balance = 1
     */
    balance?: Money;
}
/**
 * @generated from protobuf message rd.api.accounting.CreateExternalTransactionReq
 */
export interface CreateExternalTransactionReq {
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 1
     */
    amount?: Money; // positive
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction.Type type = 3
     */
    type: ExternalTransaction_Type;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp transacted_at = 4
     */
    transactedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction.PaymentMethod payment_method = 5
     */
    paymentMethod: ExternalTransaction_PaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 6
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 7
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string description = 9
     */
    description: string;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 10
     */
    allocationsByChartOfAccountId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID order_shipment_ids = 11
     */
    orderShipmentIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 12
     */
    externalAccountId?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.CreateExternalTransactionRes
 */
export interface CreateExternalTransactionRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateExternalTransactionReq
 */
export interface UpdateExternalTransactionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 2
     */
    amount?: Money; // positive
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 3
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp transacted_at = 4
     */
    transactedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction.PaymentMethod payment_method = 5
     */
    paymentMethod: ExternalTransaction_PaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 6
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 7
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string description = 9
     */
    description: string;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 10
     */
    allocationsByChartOfAccountId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID order_shipment_ids = 11
     */
    orderShipmentIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 12
     */
    externalAccountId?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.UpdateExternalTransactionRes
 */
export interface UpdateExternalTransactionRes {
}
/**
 * @generated from protobuf message rd.api.accounting.VoidExternalTransactionReq
 */
export interface VoidExternalTransactionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.VoidExternalTransactionRes
 */
export interface VoidExternalTransactionRes {
}
/**
 * @generated from protobuf message rd.api.accounting.GetExternalTransactionReq
 */
export interface GetExternalTransactionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GetExternalTransactionRes
 */
export interface GetExternalTransactionRes {
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction external_transaction = 1
     */
    externalTransaction?: ExternalTransaction;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: map<string, rd.coa.Account> accounts_by_id = 3
     */
    accountsById: {
        [key: string]: Account;
    };
    /**
     * @generated from protobuf field: rd.company.Location location = 4
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 5
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: map<string, rd.api.accounting.GetExternalTransactionRes.OrderShipmentData> order_shipment_data_by_id = 6
     */
    orderShipmentDataById: {
        [key: string]: GetExternalTransactionRes_OrderShipmentData;
    };
}
/**
 * @generated from protobuf message rd.api.accounting.GetExternalTransactionRes.OrderShipmentData
 */
export interface GetExternalTransactionRes_OrderShipmentData {
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 1
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 3
     */
    total?: Money;
}
/**
 * Journal entries
 *
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesReq
 */
export interface GenerateJournalEntriesReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesRes
 */
export interface GenerateJournalEntriesRes {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesPDFReq
 */
export interface GenerateJournalEntriesPDFReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesPDFRes
 */
export interface GenerateJournalEntriesPDFRes {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesIIFReq
 */
export interface GenerateJournalEntriesIIFReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesIIFRes
 */
export interface GenerateJournalEntriesIIFRes {
}
/**
 * Payout reconciliation
 *
 * @generated from protobuf message rd.api.accounting.GeneratePayoutReconciliationReq
 */
export interface GeneratePayoutReconciliationReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GeneratePayoutReconciliationRes
 */
export interface GeneratePayoutReconciliationRes {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateGeneralLedgerReq
 */
export interface GenerateGeneralLedgerReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateGeneralLedgerRes
 */
export interface GenerateGeneralLedgerRes {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateGeneralLedgerPDFReq
 */
export interface GenerateGeneralLedgerPDFReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateGeneralLedgerPDFRes
 */
export interface GenerateGeneralLedgerPDFRes {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateGeneralLedgerCSVReq
 */
export interface GenerateGeneralLedgerCSVReq {
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateGeneralLedgerCSVRes
 */
export interface GenerateGeneralLedgerCSVRes {
}
/**
 * Journal Entry
 *
 * @generated from protobuf message rd.api.accounting.GetJournalEntryReq
 */
export interface GetJournalEntryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GetJournalEntryRes
 */
export interface GetJournalEntryRes {
    /**
     * @generated from protobuf field: rd.accounting.JournalEntry journal_entry = 1
     */
    journalEntry?: JournalEntry;
    /**
     * @generated from protobuf field: map<string, string> breakdown_names_by_id = 3
     */
    breakdownNamesById: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesV2Req
 */
export interface GenerateJournalEntriesV2Req {
    /**
     * @generated from protobuf field: rd.accounting.JournalEntry.Type type = 1
     */
    type: JournalEntry_Type;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange timestamp_range = 2
     */
    timestampRange?: TimestampRange;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
    /**
     * @generated from protobuf field: bool is_batched = 4
     */
    isBatched: boolean;
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntriesV2Res
 */
export interface GenerateJournalEntriesV2Res {
    /**
     * @generated from protobuf field: int32 num_generated = 1
     */
    numGenerated: number;
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntryForOrderShipmentReq
 */
export interface GenerateJournalEntryForOrderShipmentReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 1
     */
    orderShipmentId?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GenerateJournalEntryForOrderShipmentRes
 */
export interface GenerateJournalEntryForOrderShipmentRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.ExportJournalEntryToQuickbooksOnlineReq
 */
export interface ExportJournalEntryToQuickbooksOnlineReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.ExportJournalEntryToQuickbooksOnlineRes
 */
export interface ExportJournalEntryToQuickbooksOnlineRes {
    /**
     * @generated from protobuf field: repeated string quickbooks_online_urls = 1
     */
    quickbooksOnlineUrls: string[];
}
/**
 * @generated from protobuf message rd.api.accounting.GetJournalEntryQuickbooksDesktopIIFReq
 */
export interface GetJournalEntryQuickbooksDesktopIIFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GetJournalEntryQuickbooksDesktopIIFRes
 */
export interface GetJournalEntryQuickbooksDesktopIIFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.accounting.GetJournalEntrySage100CSVReq
 */
export interface GetJournalEntrySage100CSVReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.GetJournalEntrySage100CSVRes
 */
export interface GetJournalEntrySage100CSVRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.accounting.ArchiveJournalEntryReq
 */
export interface ArchiveJournalEntryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.ArchiveJournalEntryRes
 */
export interface ArchiveJournalEntryRes {
}
/**
 * @generated from protobuf message rd.api.accounting.DownloadJournalEntryCSVReq
 */
export interface DownloadJournalEntryCSVReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.accounting.DownloadJournalEntryCSVRes
 */
export interface DownloadJournalEntryCSVRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountReq$Type extends MessageType<CreateAccountReq> {
    constructor() {
        super("rd.api.accounting.CreateAccountReq", [
            { no: 1, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.validator.require": true } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "type", kind: "enum", T: () => ["rd.coa.Account.Type", Account_Type], options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateAccountReq>): CreateAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.number = 0;
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountReq): CreateAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 number */ 1:
                    message.number = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* rd.coa.Account.Type type */ 4:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 number = 1; */
        if (message.number !== 0)
            writer.tag(1, WireType.Varint).int32(message.number);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* rd.coa.Account.Type type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.CreateAccountReq
 */
export const CreateAccountReq = new CreateAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountRes$Type extends MessageType<CreateAccountRes> {
    constructor() {
        super("rd.api.accounting.CreateAccountRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateAccountRes>): CreateAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountRes): CreateAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.CreateAccountRes
 */
export const CreateAccountRes = new CreateAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsReq$Type extends MessageType<ListAccountsReq> {
    constructor() {
        super("rd.api.accounting.ListAccountsReq", [
            { no: 2, name: "account_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 3, name: "filter_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListAccountsReq>): ListAccountsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountTypes = [];
        message.filterActive = false;
        if (value !== undefined)
            reflectionMergePartial<ListAccountsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsReq): ListAccountsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.coa.Account.Type account_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountTypes.push(reader.int32());
                    else
                        message.accountTypes.push(reader.int32());
                    break;
                case /* bool filter_active */ 3:
                    message.filterActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.coa.Account.Type account_types = 2; */
        if (message.accountTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountTypes.length; i++)
                writer.int32(message.accountTypes[i]);
            writer.join();
        }
        /* bool filter_active = 3; */
        if (message.filterActive !== false)
            writer.tag(3, WireType.Varint).bool(message.filterActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ListAccountsReq
 */
export const ListAccountsReq = new ListAccountsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsRes$Type extends MessageType<ListAccountsRes> {
    constructor() {
        super("rd.api.accounting.ListAccountsRes", [
            { no: 3, name: "accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Account }
        ]);
    }
    create(value?: PartialMessage<ListAccountsRes>): ListAccountsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accounts = [];
        if (value !== undefined)
            reflectionMergePartial<ListAccountsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsRes): ListAccountsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.coa.Account accounts */ 3:
                    message.accounts.push(Account.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.coa.Account accounts = 3; */
        for (let i = 0; i < message.accounts.length; i++)
            Account.internalBinaryWrite(message.accounts[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ListAccountsRes
 */
export const ListAccountsRes = new ListAccountsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountReq$Type extends MessageType<GetAccountReq> {
    constructor() {
        super("rd.api.accounting.GetAccountReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetAccountReq>): GetAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountReq): GetAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetAccountReq
 */
export const GetAccountReq = new GetAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountRes$Type extends MessageType<GetAccountRes> {
    constructor() {
        super("rd.api.accounting.GetAccountRes", [
            { no: 1, name: "account", kind: "message", T: () => Account }
        ]);
    }
    create(value?: PartialMessage<GetAccountRes>): GetAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountRes): GetAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.coa.Account account */ 1:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.coa.Account account = 1; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetAccountRes
 */
export const GetAccountRes = new GetAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccountReq$Type extends MessageType<UpdateAccountReq> {
    constructor() {
        super("rd.api.accounting.UpdateAccountReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.validator.require": true } },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 5, name: "type", kind: "enum", T: () => ["rd.coa.Account.Type", Account_Type], options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateAccountReq>): UpdateAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.number = 0;
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccountReq): UpdateAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* int32 number */ 2:
                    message.number = reader.int32();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* rd.coa.Account.Type type */ 5:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 number = 2; */
        if (message.number !== 0)
            writer.tag(2, WireType.Varint).int32(message.number);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* rd.coa.Account.Type type = 5; */
        if (message.type !== 0)
            writer.tag(5, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateAccountReq
 */
export const UpdateAccountReq = new UpdateAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccountRes$Type extends MessageType<UpdateAccountRes> {
    constructor() {
        super("rd.api.accounting.UpdateAccountRes", []);
    }
    create(value?: PartialMessage<UpdateAccountRes>): UpdateAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccountRes): UpdateAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateAccountRes
 */
export const UpdateAccountRes = new UpdateAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateAccountReq$Type extends MessageType<DeactivateAccountReq> {
    constructor() {
        super("rd.api.accounting.DeactivateAccountReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateAccountReq>): DeactivateAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateAccountReq): DeactivateAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.DeactivateAccountReq
 */
export const DeactivateAccountReq = new DeactivateAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateAccountRes$Type extends MessageType<DeactivateAccountRes> {
    constructor() {
        super("rd.api.accounting.DeactivateAccountRes", []);
    }
    create(value?: PartialMessage<DeactivateAccountRes>): DeactivateAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateAccountRes): DeactivateAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.DeactivateAccountRes
 */
export const DeactivateAccountRes = new DeactivateAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReactivateAccountReq$Type extends MessageType<ReactivateAccountReq> {
    constructor() {
        super("rd.api.accounting.ReactivateAccountReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReactivateAccountReq>): ReactivateAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReactivateAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReactivateAccountReq): ReactivateAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReactivateAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ReactivateAccountReq
 */
export const ReactivateAccountReq = new ReactivateAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReactivateAccountRes$Type extends MessageType<ReactivateAccountRes> {
    constructor() {
        super("rd.api.accounting.ReactivateAccountRes", []);
    }
    create(value?: PartialMessage<ReactivateAccountRes>): ReactivateAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReactivateAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReactivateAccountRes): ReactivateAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReactivateAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ReactivateAccountRes
 */
export const ReactivateAccountRes = new ReactivateAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertAccountsReq$Type extends MessageType<BulkUpsertAccountsReq> {
    constructor() {
        super("rd.api.accounting.BulkUpsertAccountsReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertAccountsReq>): BulkUpsertAccountsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertAccountsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertAccountsReq): BulkUpsertAccountsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertAccountsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.BulkUpsertAccountsReq
 */
export const BulkUpsertAccountsReq = new BulkUpsertAccountsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertAccountsRes$Type extends MessageType<BulkUpsertAccountsRes> {
    constructor() {
        super("rd.api.accounting.BulkUpsertAccountsRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertAccountsRes>): BulkUpsertAccountsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertAccountsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertAccountsRes): BulkUpsertAccountsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertAccountsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.BulkUpsertAccountsRes
 */
export const BulkUpsertAccountsRes = new BulkUpsertAccountsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMappingsReq$Type extends MessageType<ListMappingsReq> {
    constructor() {
        super("rd.api.accounting.ListMappingsReq", [
            { no: 1, name: "filter_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListMappingsReq>): ListMappingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterActive = false;
        if (value !== undefined)
            reflectionMergePartial<ListMappingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMappingsReq): ListMappingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool filter_active */ 1:
                    message.filterActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMappingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool filter_active = 1; */
        if (message.filterActive !== false)
            writer.tag(1, WireType.Varint).bool(message.filterActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ListMappingsReq
 */
export const ListMappingsReq = new ListMappingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMappingsRes$Type extends MessageType<ListMappingsRes> {
    constructor() {
        super("rd.api.accounting.ListMappingsRes", [
            { no: 1, name: "mappings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Mapping }
        ]);
    }
    create(value?: PartialMessage<ListMappingsRes>): ListMappingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mappings = [];
        if (value !== undefined)
            reflectionMergePartial<ListMappingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMappingsRes): ListMappingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.coa.Mapping mappings */ 1:
                    message.mappings.push(Mapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMappingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.coa.Mapping mappings = 1; */
        for (let i = 0; i < message.mappings.length; i++)
            Mapping.internalBinaryWrite(message.mappings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ListMappingsRes
 */
export const ListMappingsRes = new ListMappingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMappingAccountReq$Type extends MessageType<UpdateMappingAccountReq> {
    constructor() {
        super("rd.api.accounting.UpdateMappingAccountReq", [
            { no: 1, name: "mapping_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "should_be_separate_row", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateMappingAccountReq>): UpdateMappingAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mappingIds = [];
        message.shouldBeSeparateRow = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateMappingAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateMappingAccountReq): UpdateMappingAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID mapping_ids */ 1:
                    message.mappingIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID account_id */ 2:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* bool should_be_separate_row */ 3:
                    message.shouldBeSeparateRow = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateMappingAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID mapping_ids = 1; */
        for (let i = 0; i < message.mappingIds.length; i++)
            UUID.internalBinaryWrite(message.mappingIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID account_id = 2; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool should_be_separate_row = 3; */
        if (message.shouldBeSeparateRow !== false)
            writer.tag(3, WireType.Varint).bool(message.shouldBeSeparateRow);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateMappingAccountReq
 */
export const UpdateMappingAccountReq = new UpdateMappingAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMappingAccountRes$Type extends MessageType<UpdateMappingAccountRes> {
    constructor() {
        super("rd.api.accounting.UpdateMappingAccountRes", []);
    }
    create(value?: PartialMessage<UpdateMappingAccountRes>): UpdateMappingAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateMappingAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateMappingAccountRes): UpdateMappingAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateMappingAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateMappingAccountRes
 */
export const UpdateMappingAccountRes = new UpdateMappingAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertMappingsReq$Type extends MessageType<BulkUpsertMappingsReq> {
    constructor() {
        super("rd.api.accounting.BulkUpsertMappingsReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertMappingsReq>): BulkUpsertMappingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertMappingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertMappingsReq): BulkUpsertMappingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertMappingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.BulkUpsertMappingsReq
 */
export const BulkUpsertMappingsReq = new BulkUpsertMappingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertMappingsRes$Type extends MessageType<BulkUpsertMappingsRes> {
    constructor() {
        super("rd.api.accounting.BulkUpsertMappingsRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertMappingsRes>): BulkUpsertMappingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertMappingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertMappingsRes): BulkUpsertMappingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertMappingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.BulkUpsertMappingsRes
 */
export const BulkUpsertMappingsRes = new BulkUpsertMappingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateIncomeStatementReq$Type extends MessageType<GenerateIncomeStatementReq> {
    constructor() {
        super("rd.api.accounting.GenerateIncomeStatementReq", []);
    }
    create(value?: PartialMessage<GenerateIncomeStatementReq>): GenerateIncomeStatementReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateIncomeStatementReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateIncomeStatementReq): GenerateIncomeStatementReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateIncomeStatementReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateIncomeStatementReq
 */
export const GenerateIncomeStatementReq = new GenerateIncomeStatementReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateIncomeStatementRes$Type extends MessageType<GenerateIncomeStatementRes> {
    constructor() {
        super("rd.api.accounting.GenerateIncomeStatementRes", []);
    }
    create(value?: PartialMessage<GenerateIncomeStatementRes>): GenerateIncomeStatementRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateIncomeStatementRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateIncomeStatementRes): GenerateIncomeStatementRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateIncomeStatementRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateIncomeStatementRes
 */
export const GenerateIncomeStatementRes = new GenerateIncomeStatementRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateBalanceSheetReq$Type extends MessageType<GenerateBalanceSheetReq> {
    constructor() {
        super("rd.api.accounting.GenerateBalanceSheetReq", []);
    }
    create(value?: PartialMessage<GenerateBalanceSheetReq>): GenerateBalanceSheetReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateBalanceSheetReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateBalanceSheetReq): GenerateBalanceSheetReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateBalanceSheetReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateBalanceSheetReq
 */
export const GenerateBalanceSheetReq = new GenerateBalanceSheetReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateBalanceSheetRes$Type extends MessageType<GenerateBalanceSheetRes> {
    constructor() {
        super("rd.api.accounting.GenerateBalanceSheetRes", []);
    }
    create(value?: PartialMessage<GenerateBalanceSheetRes>): GenerateBalanceSheetRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateBalanceSheetRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateBalanceSheetRes): GenerateBalanceSheetRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateBalanceSheetRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateBalanceSheetRes
 */
export const GenerateBalanceSheetRes = new GenerateBalanceSheetRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalAccountReq$Type extends MessageType<CreateExternalAccountReq> {
    constructor() {
        super("rd.api.accounting.CreateExternalAccountReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.accounting.ExternalAccount.Type", ExternalAccount_Type, "TYPE_"], options: { "rd.validator.require": true } },
            { no: 3, name: "coa_account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExternalAccountReq>): CreateExternalAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.last4 = "";
        if (value !== undefined)
            reflectionMergePartial<CreateExternalAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExternalAccountReq): CreateExternalAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.accounting.ExternalAccount.Type type */ 2:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID coa_account_id */ 3:
                    message.coaAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.coaAccountId);
                    break;
                case /* string last_4 */ 4:
                    message.last4 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExternalAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.accounting.ExternalAccount.Type type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID coa_account_id = 3; */
        if (message.coaAccountId)
            UUID.internalBinaryWrite(message.coaAccountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string last_4 = 4; */
        if (message.last4 !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.last4);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.CreateExternalAccountReq
 */
export const CreateExternalAccountReq = new CreateExternalAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalAccountRes$Type extends MessageType<CreateExternalAccountRes> {
    constructor() {
        super("rd.api.accounting.CreateExternalAccountRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateExternalAccountRes>): CreateExternalAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateExternalAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExternalAccountRes): CreateExternalAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExternalAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.CreateExternalAccountRes
 */
export const CreateExternalAccountRes = new CreateExternalAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalAccountReq$Type extends MessageType<UpdateExternalAccountReq> {
    constructor() {
        super("rd.api.accounting.UpdateExternalAccountReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "type", kind: "enum", T: () => ["rd.accounting.ExternalAccount.Type", ExternalAccount_Type, "TYPE_"], options: { "rd.validator.require": true } },
            { no: 4, name: "coa_account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 5, name: "last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExternalAccountReq>): UpdateExternalAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.last4 = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateExternalAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExternalAccountReq): UpdateExternalAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.accounting.ExternalAccount.Type type */ 3:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID coa_account_id */ 4:
                    message.coaAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.coaAccountId);
                    break;
                case /* string last_4 */ 5:
                    message.last4 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExternalAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.accounting.ExternalAccount.Type type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID coa_account_id = 4; */
        if (message.coaAccountId)
            UUID.internalBinaryWrite(message.coaAccountId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string last_4 = 5; */
        if (message.last4 !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.last4);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateExternalAccountReq
 */
export const UpdateExternalAccountReq = new UpdateExternalAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalAccountRes$Type extends MessageType<UpdateExternalAccountRes> {
    constructor() {
        super("rd.api.accounting.UpdateExternalAccountRes", []);
    }
    create(value?: PartialMessage<UpdateExternalAccountRes>): UpdateExternalAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateExternalAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExternalAccountRes): UpdateExternalAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExternalAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateExternalAccountRes
 */
export const UpdateExternalAccountRes = new UpdateExternalAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateExternalAccountReq$Type extends MessageType<DeactivateExternalAccountReq> {
    constructor() {
        super("rd.api.accounting.DeactivateExternalAccountReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateExternalAccountReq>): DeactivateExternalAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateExternalAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateExternalAccountReq): DeactivateExternalAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateExternalAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.DeactivateExternalAccountReq
 */
export const DeactivateExternalAccountReq = new DeactivateExternalAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateExternalAccountRes$Type extends MessageType<DeactivateExternalAccountRes> {
    constructor() {
        super("rd.api.accounting.DeactivateExternalAccountRes", []);
    }
    create(value?: PartialMessage<DeactivateExternalAccountRes>): DeactivateExternalAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateExternalAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateExternalAccountRes): DeactivateExternalAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateExternalAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.DeactivateExternalAccountRes
 */
export const DeactivateExternalAccountRes = new DeactivateExternalAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExternalAccountsReq$Type extends MessageType<ListExternalAccountsReq> {
    constructor() {
        super("rd.api.accounting.ListExternalAccountsReq", [
            { no: 1, name: "active_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListExternalAccountsReq>): ListExternalAccountsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.activeOnly = false;
        if (value !== undefined)
            reflectionMergePartial<ListExternalAccountsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExternalAccountsReq): ListExternalAccountsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool active_only */ 1:
                    message.activeOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExternalAccountsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool active_only = 1; */
        if (message.activeOnly !== false)
            writer.tag(1, WireType.Varint).bool(message.activeOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ListExternalAccountsReq
 */
export const ListExternalAccountsReq = new ListExternalAccountsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExternalAccountsRes$Type extends MessageType<ListExternalAccountsRes> {
    constructor() {
        super("rd.api.accounting.ListExternalAccountsRes", [
            { no: 1, name: "accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalAccount }
        ]);
    }
    create(value?: PartialMessage<ListExternalAccountsRes>): ListExternalAccountsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accounts = [];
        if (value !== undefined)
            reflectionMergePartial<ListExternalAccountsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExternalAccountsRes): ListExternalAccountsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.accounting.ExternalAccount accounts */ 1:
                    message.accounts.push(ExternalAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExternalAccountsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.accounting.ExternalAccount accounts = 1; */
        for (let i = 0; i < message.accounts.length; i++)
            ExternalAccount.internalBinaryWrite(message.accounts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ListExternalAccountsRes
 */
export const ListExternalAccountsRes = new ListExternalAccountsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalAccountBalanceReq$Type extends MessageType<GetExternalAccountBalanceReq> {
    constructor() {
        super("rd.api.accounting.GetExternalAccountBalanceReq", [
            { no: 1, name: "external_account_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetExternalAccountBalanceReq>): GetExternalAccountBalanceReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExternalAccountBalanceReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalAccountBalanceReq): GetExternalAccountBalanceReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID external_account_id */ 1:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalAccountBalanceReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID external_account_id = 1; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetExternalAccountBalanceReq
 */
export const GetExternalAccountBalanceReq = new GetExternalAccountBalanceReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalAccountBalanceRes$Type extends MessageType<GetExternalAccountBalanceRes> {
    constructor() {
        super("rd.api.accounting.GetExternalAccountBalanceRes", [
            { no: 1, name: "balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<GetExternalAccountBalanceRes>): GetExternalAccountBalanceRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExternalAccountBalanceRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalAccountBalanceRes): GetExternalAccountBalanceRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money balance */ 1:
                    message.balance = Money.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalAccountBalanceRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money balance = 1; */
        if (message.balance)
            Money.internalBinaryWrite(message.balance, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetExternalAccountBalanceRes
 */
export const GetExternalAccountBalanceRes = new GetExternalAccountBalanceRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTransactionReq$Type extends MessageType<CreateExternalTransactionReq> {
    constructor() {
        super("rd.api.accounting.CreateExternalTransactionReq", [
            { no: 1, name: "amount", kind: "message", T: () => Money, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "type", kind: "enum", T: () => ["rd.accounting.ExternalTransaction.Type", ExternalTransaction_Type, "TYPE_"], options: { "rd.validator.require": true } },
            { no: 4, name: "transacted_at", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 5, name: "payment_method", kind: "enum", T: () => ["rd.accounting.ExternalTransaction.PaymentMethod", ExternalTransaction_PaymentMethod, "PAYMENT_METHOD_"], options: { "rd.validator.require": true } },
            { no: 6, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 9, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "allocations_by_chart_of_account_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 11, name: "order_shipment_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "external_account_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateExternalTransactionReq>): CreateExternalTransactionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.paymentMethod = 0;
        message.description = "";
        message.allocationsByChartOfAccountId = {};
        message.orderShipmentIds = [];
        if (value !== undefined)
            reflectionMergePartial<CreateExternalTransactionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExternalTransactionReq): CreateExternalTransactionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money amount */ 1:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.accounting.ExternalTransaction.Type type */ 3:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Timestamp transacted_at */ 4:
                    message.transactedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.transactedAt);
                    break;
                case /* rd.accounting.ExternalTransaction.PaymentMethod payment_method */ 5:
                    message.paymentMethod = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 6:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 7:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string description */ 9:
                    message.description = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id */ 10:
                    this.binaryReadMap10(message.allocationsByChartOfAccountId, reader, options);
                    break;
                case /* repeated rd.proto.uuid.UUID order_shipment_ids */ 11:
                    message.orderShipmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID external_account_id */ 12:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap10(map: CreateExternalTransactionReq["allocationsByChartOfAccountId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CreateExternalTransactionReq["allocationsByChartOfAccountId"] | undefined, val: CreateExternalTransactionReq["allocationsByChartOfAccountId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.accounting.CreateExternalTransactionReq.allocations_by_chart_of_account_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CreateExternalTransactionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money amount = 1; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalTransaction.Type type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* google.protobuf.Timestamp transacted_at = 4; */
        if (message.transactedAt)
            Timestamp.internalBinaryWrite(message.transactedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalTransaction.PaymentMethod payment_method = 5; */
        if (message.paymentMethod !== 0)
            writer.tag(5, WireType.Varint).int32(message.paymentMethod);
        /* rd.proto.uuid.UUID customer_id = 6; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 7; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string description = 9; */
        if (message.description !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.description);
        /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 10; */
        for (let k of globalThis.Object.keys(message.allocationsByChartOfAccountId)) {
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsByChartOfAccountId[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.proto.uuid.UUID order_shipment_ids = 11; */
        for (let i = 0; i < message.orderShipmentIds.length; i++)
            UUID.internalBinaryWrite(message.orderShipmentIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID external_account_id = 12; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.CreateExternalTransactionReq
 */
export const CreateExternalTransactionReq = new CreateExternalTransactionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTransactionRes$Type extends MessageType<CreateExternalTransactionRes> {
    constructor() {
        super("rd.api.accounting.CreateExternalTransactionRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateExternalTransactionRes>): CreateExternalTransactionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateExternalTransactionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExternalTransactionRes): CreateExternalTransactionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExternalTransactionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.CreateExternalTransactionRes
 */
export const CreateExternalTransactionRes = new CreateExternalTransactionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalTransactionReq$Type extends MessageType<UpdateExternalTransactionReq> {
    constructor() {
        super("rd.api.accounting.UpdateExternalTransactionReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "amount", kind: "message", T: () => Money, options: { "rd.validator.require": true } },
            { no: 3, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "transacted_at", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 5, name: "payment_method", kind: "enum", T: () => ["rd.accounting.ExternalTransaction.PaymentMethod", ExternalTransaction_PaymentMethod, "PAYMENT_METHOD_"], options: { "rd.validator.require": true } },
            { no: 6, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 9, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "allocations_by_chart_of_account_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 11, name: "order_shipment_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "external_account_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<UpdateExternalTransactionReq>): UpdateExternalTransactionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paymentMethod = 0;
        message.description = "";
        message.allocationsByChartOfAccountId = {};
        message.orderShipmentIds = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateExternalTransactionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExternalTransactionReq): UpdateExternalTransactionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.money.Money amount */ 2:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 3:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp transacted_at */ 4:
                    message.transactedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.transactedAt);
                    break;
                case /* rd.accounting.ExternalTransaction.PaymentMethod payment_method */ 5:
                    message.paymentMethod = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 6:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 7:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string description */ 9:
                    message.description = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id */ 10:
                    this.binaryReadMap10(message.allocationsByChartOfAccountId, reader, options);
                    break;
                case /* repeated rd.proto.uuid.UUID order_shipment_ids */ 11:
                    message.orderShipmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID external_account_id */ 12:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap10(map: UpdateExternalTransactionReq["allocationsByChartOfAccountId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateExternalTransactionReq["allocationsByChartOfAccountId"] | undefined, val: UpdateExternalTransactionReq["allocationsByChartOfAccountId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.accounting.UpdateExternalTransactionReq.allocations_by_chart_of_account_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: UpdateExternalTransactionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount = 2; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 3; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp transacted_at = 4; */
        if (message.transactedAt)
            Timestamp.internalBinaryWrite(message.transactedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalTransaction.PaymentMethod payment_method = 5; */
        if (message.paymentMethod !== 0)
            writer.tag(5, WireType.Varint).int32(message.paymentMethod);
        /* rd.proto.uuid.UUID customer_id = 6; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 7; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string description = 9; */
        if (message.description !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.description);
        /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 10; */
        for (let k of globalThis.Object.keys(message.allocationsByChartOfAccountId)) {
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsByChartOfAccountId[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.proto.uuid.UUID order_shipment_ids = 11; */
        for (let i = 0; i < message.orderShipmentIds.length; i++)
            UUID.internalBinaryWrite(message.orderShipmentIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID external_account_id = 12; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateExternalTransactionReq
 */
export const UpdateExternalTransactionReq = new UpdateExternalTransactionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalTransactionRes$Type extends MessageType<UpdateExternalTransactionRes> {
    constructor() {
        super("rd.api.accounting.UpdateExternalTransactionRes", []);
    }
    create(value?: PartialMessage<UpdateExternalTransactionRes>): UpdateExternalTransactionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateExternalTransactionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExternalTransactionRes): UpdateExternalTransactionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExternalTransactionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.UpdateExternalTransactionRes
 */
export const UpdateExternalTransactionRes = new UpdateExternalTransactionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidExternalTransactionReq$Type extends MessageType<VoidExternalTransactionReq> {
    constructor() {
        super("rd.api.accounting.VoidExternalTransactionReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<VoidExternalTransactionReq>): VoidExternalTransactionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidExternalTransactionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidExternalTransactionReq): VoidExternalTransactionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidExternalTransactionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.VoidExternalTransactionReq
 */
export const VoidExternalTransactionReq = new VoidExternalTransactionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidExternalTransactionRes$Type extends MessageType<VoidExternalTransactionRes> {
    constructor() {
        super("rd.api.accounting.VoidExternalTransactionRes", []);
    }
    create(value?: PartialMessage<VoidExternalTransactionRes>): VoidExternalTransactionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidExternalTransactionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidExternalTransactionRes): VoidExternalTransactionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidExternalTransactionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.VoidExternalTransactionRes
 */
export const VoidExternalTransactionRes = new VoidExternalTransactionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTransactionReq$Type extends MessageType<GetExternalTransactionReq> {
    constructor() {
        super("rd.api.accounting.GetExternalTransactionReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetExternalTransactionReq>): GetExternalTransactionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExternalTransactionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTransactionReq): GetExternalTransactionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalTransactionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetExternalTransactionReq
 */
export const GetExternalTransactionReq = new GetExternalTransactionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTransactionRes$Type extends MessageType<GetExternalTransactionRes> {
    constructor() {
        super("rd.api.accounting.GetExternalTransactionRes", [
            { no: 1, name: "external_transaction", kind: "message", T: () => ExternalTransaction },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "accounts_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Account } },
            { no: 4, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "customer", kind: "message", T: () => Customer },
            { no: 6, name: "order_shipment_data_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GetExternalTransactionRes_OrderShipmentData } }
        ]);
    }
    create(value?: PartialMessage<GetExternalTransactionRes>): GetExternalTransactionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountsById = {};
        message.orderShipmentDataById = {};
        if (value !== undefined)
            reflectionMergePartial<GetExternalTransactionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTransactionRes): GetExternalTransactionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.ExternalTransaction external_transaction */ 1:
                    message.externalTransaction = ExternalTransaction.internalBinaryRead(reader, reader.uint32(), options, message.externalTransaction);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* map<string, rd.coa.Account> accounts_by_id */ 3:
                    this.binaryReadMap3(message.accountsById, reader, options);
                    break;
                case /* rd.company.Location location */ 4:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.Customer customer */ 5:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* map<string, rd.api.accounting.GetExternalTransactionRes.OrderShipmentData> order_shipment_data_by_id */ 6:
                    this.binaryReadMap6(message.orderShipmentDataById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: GetExternalTransactionRes["accountsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetExternalTransactionRes["accountsById"] | undefined, val: GetExternalTransactionRes["accountsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Account.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.accounting.GetExternalTransactionRes.accounts_by_id");
            }
        }
        map[key ?? ""] = val ?? Account.create();
    }
    private binaryReadMap6(map: GetExternalTransactionRes["orderShipmentDataById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetExternalTransactionRes["orderShipmentDataById"] | undefined, val: GetExternalTransactionRes["orderShipmentDataById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GetExternalTransactionRes_OrderShipmentData.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.accounting.GetExternalTransactionRes.order_shipment_data_by_id");
            }
        }
        map[key ?? ""] = val ?? GetExternalTransactionRes_OrderShipmentData.create();
    }
    internalBinaryWrite(message: GetExternalTransactionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.ExternalTransaction external_transaction = 1; */
        if (message.externalTransaction)
            ExternalTransaction.internalBinaryWrite(message.externalTransaction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.coa.Account> accounts_by_id = 3; */
        for (let k of globalThis.Object.keys(message.accountsById)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Account.internalBinaryWrite(message.accountsById[k], writer, options);
            writer.join().join();
        }
        /* rd.company.Location location = 4; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 5; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.accounting.GetExternalTransactionRes.OrderShipmentData> order_shipment_data_by_id = 6; */
        for (let k of globalThis.Object.keys(message.orderShipmentDataById)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GetExternalTransactionRes_OrderShipmentData.internalBinaryWrite(message.orderShipmentDataById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetExternalTransactionRes
 */
export const GetExternalTransactionRes = new GetExternalTransactionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTransactionRes_OrderShipmentData$Type extends MessageType<GetExternalTransactionRes_OrderShipmentData> {
    constructor() {
        super("rd.api.accounting.GetExternalTransactionRes.OrderShipmentData", [
            { no: 1, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<GetExternalTransactionRes_OrderShipmentData>): GetExternalTransactionRes_OrderShipmentData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExternalTransactionRes_OrderShipmentData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTransactionRes_OrderShipmentData): GetExternalTransactionRes_OrderShipmentData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.OrderShipment order_shipment */ 1:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.proto.money.Money total */ 3:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalTransactionRes_OrderShipmentData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.OrderShipment order_shipment = 1; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 3; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetExternalTransactionRes.OrderShipmentData
 */
export const GetExternalTransactionRes_OrderShipmentData = new GetExternalTransactionRes_OrderShipmentData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesReq$Type extends MessageType<GenerateJournalEntriesReq> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesReq", []);
    }
    create(value?: PartialMessage<GenerateJournalEntriesReq>): GenerateJournalEntriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesReq): GenerateJournalEntriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesReq
 */
export const GenerateJournalEntriesReq = new GenerateJournalEntriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesRes$Type extends MessageType<GenerateJournalEntriesRes> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesRes", []);
    }
    create(value?: PartialMessage<GenerateJournalEntriesRes>): GenerateJournalEntriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesRes): GenerateJournalEntriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesRes
 */
export const GenerateJournalEntriesRes = new GenerateJournalEntriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesPDFReq$Type extends MessageType<GenerateJournalEntriesPDFReq> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesPDFReq", []);
    }
    create(value?: PartialMessage<GenerateJournalEntriesPDFReq>): GenerateJournalEntriesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesPDFReq): GenerateJournalEntriesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesPDFReq
 */
export const GenerateJournalEntriesPDFReq = new GenerateJournalEntriesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesPDFRes$Type extends MessageType<GenerateJournalEntriesPDFRes> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesPDFRes", []);
    }
    create(value?: PartialMessage<GenerateJournalEntriesPDFRes>): GenerateJournalEntriesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesPDFRes): GenerateJournalEntriesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesPDFRes
 */
export const GenerateJournalEntriesPDFRes = new GenerateJournalEntriesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesIIFReq$Type extends MessageType<GenerateJournalEntriesIIFReq> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesIIFReq", []);
    }
    create(value?: PartialMessage<GenerateJournalEntriesIIFReq>): GenerateJournalEntriesIIFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesIIFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesIIFReq): GenerateJournalEntriesIIFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesIIFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesIIFReq
 */
export const GenerateJournalEntriesIIFReq = new GenerateJournalEntriesIIFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesIIFRes$Type extends MessageType<GenerateJournalEntriesIIFRes> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesIIFRes", []);
    }
    create(value?: PartialMessage<GenerateJournalEntriesIIFRes>): GenerateJournalEntriesIIFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesIIFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesIIFRes): GenerateJournalEntriesIIFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesIIFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesIIFRes
 */
export const GenerateJournalEntriesIIFRes = new GenerateJournalEntriesIIFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePayoutReconciliationReq$Type extends MessageType<GeneratePayoutReconciliationReq> {
    constructor() {
        super("rd.api.accounting.GeneratePayoutReconciliationReq", []);
    }
    create(value?: PartialMessage<GeneratePayoutReconciliationReq>): GeneratePayoutReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GeneratePayoutReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneratePayoutReconciliationReq): GeneratePayoutReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneratePayoutReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GeneratePayoutReconciliationReq
 */
export const GeneratePayoutReconciliationReq = new GeneratePayoutReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePayoutReconciliationRes$Type extends MessageType<GeneratePayoutReconciliationRes> {
    constructor() {
        super("rd.api.accounting.GeneratePayoutReconciliationRes", []);
    }
    create(value?: PartialMessage<GeneratePayoutReconciliationRes>): GeneratePayoutReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GeneratePayoutReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneratePayoutReconciliationRes): GeneratePayoutReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneratePayoutReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GeneratePayoutReconciliationRes
 */
export const GeneratePayoutReconciliationRes = new GeneratePayoutReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateGeneralLedgerReq$Type extends MessageType<GenerateGeneralLedgerReq> {
    constructor() {
        super("rd.api.accounting.GenerateGeneralLedgerReq", []);
    }
    create(value?: PartialMessage<GenerateGeneralLedgerReq>): GenerateGeneralLedgerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateGeneralLedgerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateGeneralLedgerReq): GenerateGeneralLedgerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateGeneralLedgerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateGeneralLedgerReq
 */
export const GenerateGeneralLedgerReq = new GenerateGeneralLedgerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateGeneralLedgerRes$Type extends MessageType<GenerateGeneralLedgerRes> {
    constructor() {
        super("rd.api.accounting.GenerateGeneralLedgerRes", []);
    }
    create(value?: PartialMessage<GenerateGeneralLedgerRes>): GenerateGeneralLedgerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateGeneralLedgerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateGeneralLedgerRes): GenerateGeneralLedgerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateGeneralLedgerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateGeneralLedgerRes
 */
export const GenerateGeneralLedgerRes = new GenerateGeneralLedgerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateGeneralLedgerPDFReq$Type extends MessageType<GenerateGeneralLedgerPDFReq> {
    constructor() {
        super("rd.api.accounting.GenerateGeneralLedgerPDFReq", []);
    }
    create(value?: PartialMessage<GenerateGeneralLedgerPDFReq>): GenerateGeneralLedgerPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateGeneralLedgerPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateGeneralLedgerPDFReq): GenerateGeneralLedgerPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateGeneralLedgerPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateGeneralLedgerPDFReq
 */
export const GenerateGeneralLedgerPDFReq = new GenerateGeneralLedgerPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateGeneralLedgerPDFRes$Type extends MessageType<GenerateGeneralLedgerPDFRes> {
    constructor() {
        super("rd.api.accounting.GenerateGeneralLedgerPDFRes", []);
    }
    create(value?: PartialMessage<GenerateGeneralLedgerPDFRes>): GenerateGeneralLedgerPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateGeneralLedgerPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateGeneralLedgerPDFRes): GenerateGeneralLedgerPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateGeneralLedgerPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateGeneralLedgerPDFRes
 */
export const GenerateGeneralLedgerPDFRes = new GenerateGeneralLedgerPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateGeneralLedgerCSVReq$Type extends MessageType<GenerateGeneralLedgerCSVReq> {
    constructor() {
        super("rd.api.accounting.GenerateGeneralLedgerCSVReq", []);
    }
    create(value?: PartialMessage<GenerateGeneralLedgerCSVReq>): GenerateGeneralLedgerCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateGeneralLedgerCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateGeneralLedgerCSVReq): GenerateGeneralLedgerCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateGeneralLedgerCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateGeneralLedgerCSVReq
 */
export const GenerateGeneralLedgerCSVReq = new GenerateGeneralLedgerCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateGeneralLedgerCSVRes$Type extends MessageType<GenerateGeneralLedgerCSVRes> {
    constructor() {
        super("rd.api.accounting.GenerateGeneralLedgerCSVRes", []);
    }
    create(value?: PartialMessage<GenerateGeneralLedgerCSVRes>): GenerateGeneralLedgerCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateGeneralLedgerCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateGeneralLedgerCSVRes): GenerateGeneralLedgerCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateGeneralLedgerCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateGeneralLedgerCSVRes
 */
export const GenerateGeneralLedgerCSVRes = new GenerateGeneralLedgerCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntryReq$Type extends MessageType<GetJournalEntryReq> {
    constructor() {
        super("rd.api.accounting.GetJournalEntryReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntryReq>): GetJournalEntryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntryReq): GetJournalEntryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetJournalEntryReq
 */
export const GetJournalEntryReq = new GetJournalEntryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntryRes$Type extends MessageType<GetJournalEntryRes> {
    constructor() {
        super("rd.api.accounting.GetJournalEntryRes", [
            { no: 1, name: "journal_entry", kind: "message", T: () => JournalEntry },
            { no: 3, name: "breakdown_names_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntryRes>): GetJournalEntryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.breakdownNamesById = {};
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntryRes): GetJournalEntryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.JournalEntry journal_entry */ 1:
                    message.journalEntry = JournalEntry.internalBinaryRead(reader, reader.uint32(), options, message.journalEntry);
                    break;
                case /* map<string, string> breakdown_names_by_id */ 3:
                    this.binaryReadMap3(message.breakdownNamesById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: GetJournalEntryRes["breakdownNamesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetJournalEntryRes["breakdownNamesById"] | undefined, val: GetJournalEntryRes["breakdownNamesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.accounting.GetJournalEntryRes.breakdown_names_by_id");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: GetJournalEntryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.JournalEntry journal_entry = 1; */
        if (message.journalEntry)
            JournalEntry.internalBinaryWrite(message.journalEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> breakdown_names_by_id = 3; */
        for (let k of globalThis.Object.keys(message.breakdownNamesById))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.breakdownNamesById[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetJournalEntryRes
 */
export const GetJournalEntryRes = new GetJournalEntryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesV2Req$Type extends MessageType<GenerateJournalEntriesV2Req> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesV2Req", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.accounting.JournalEntry.Type", JournalEntry_Type, "TYPE_"], options: { "rd.validator.require": true } },
            { no: 2, name: "timestamp_range", kind: "message", T: () => TimestampRange, options: { "rd.validator.require": true } },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "is_batched", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateJournalEntriesV2Req>): GenerateJournalEntriesV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.clientTimeZone = "";
        message.isBatched = false;
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesV2Req): GenerateJournalEntriesV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.JournalEntry.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange timestamp_range */ 2:
                    message.timestampRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.timestampRange);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                case /* bool is_batched */ 4:
                    message.isBatched = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.JournalEntry.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.proto.timestamprange.TimestampRange timestamp_range = 2; */
        if (message.timestampRange)
            TimestampRange.internalBinaryWrite(message.timestampRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        /* bool is_batched = 4; */
        if (message.isBatched !== false)
            writer.tag(4, WireType.Varint).bool(message.isBatched);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesV2Req
 */
export const GenerateJournalEntriesV2Req = new GenerateJournalEntriesV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntriesV2Res$Type extends MessageType<GenerateJournalEntriesV2Res> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntriesV2Res", [
            { no: 1, name: "num_generated", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateJournalEntriesV2Res>): GenerateJournalEntriesV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numGenerated = 0;
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntriesV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntriesV2Res): GenerateJournalEntriesV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 num_generated */ 1:
                    message.numGenerated = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntriesV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 num_generated = 1; */
        if (message.numGenerated !== 0)
            writer.tag(1, WireType.Varint).int32(message.numGenerated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntriesV2Res
 */
export const GenerateJournalEntriesV2Res = new GenerateJournalEntriesV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntryForOrderShipmentReq$Type extends MessageType<GenerateJournalEntryForOrderShipmentReq> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntryForOrderShipmentReq", [
            { no: 1, name: "order_shipment_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GenerateJournalEntryForOrderShipmentReq>): GenerateJournalEntryForOrderShipmentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntryForOrderShipmentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntryForOrderShipmentReq): GenerateJournalEntryForOrderShipmentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID order_shipment_id */ 1:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntryForOrderShipmentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID order_shipment_id = 1; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntryForOrderShipmentReq
 */
export const GenerateJournalEntryForOrderShipmentReq = new GenerateJournalEntryForOrderShipmentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateJournalEntryForOrderShipmentRes$Type extends MessageType<GenerateJournalEntryForOrderShipmentRes> {
    constructor() {
        super("rd.api.accounting.GenerateJournalEntryForOrderShipmentRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GenerateJournalEntryForOrderShipmentRes>): GenerateJournalEntryForOrderShipmentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateJournalEntryForOrderShipmentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateJournalEntryForOrderShipmentRes): GenerateJournalEntryForOrderShipmentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateJournalEntryForOrderShipmentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GenerateJournalEntryForOrderShipmentRes
 */
export const GenerateJournalEntryForOrderShipmentRes = new GenerateJournalEntryForOrderShipmentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportJournalEntryToQuickbooksOnlineReq$Type extends MessageType<ExportJournalEntryToQuickbooksOnlineReq> {
    constructor() {
        super("rd.api.accounting.ExportJournalEntryToQuickbooksOnlineReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ExportJournalEntryToQuickbooksOnlineReq>): ExportJournalEntryToQuickbooksOnlineReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExportJournalEntryToQuickbooksOnlineReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportJournalEntryToQuickbooksOnlineReq): ExportJournalEntryToQuickbooksOnlineReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportJournalEntryToQuickbooksOnlineReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ExportJournalEntryToQuickbooksOnlineReq
 */
export const ExportJournalEntryToQuickbooksOnlineReq = new ExportJournalEntryToQuickbooksOnlineReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportJournalEntryToQuickbooksOnlineRes$Type extends MessageType<ExportJournalEntryToQuickbooksOnlineRes> {
    constructor() {
        super("rd.api.accounting.ExportJournalEntryToQuickbooksOnlineRes", [
            { no: 1, name: "quickbooks_online_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportJournalEntryToQuickbooksOnlineRes>): ExportJournalEntryToQuickbooksOnlineRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quickbooksOnlineUrls = [];
        if (value !== undefined)
            reflectionMergePartial<ExportJournalEntryToQuickbooksOnlineRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportJournalEntryToQuickbooksOnlineRes): ExportJournalEntryToQuickbooksOnlineRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string quickbooks_online_urls */ 1:
                    message.quickbooksOnlineUrls.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportJournalEntryToQuickbooksOnlineRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string quickbooks_online_urls = 1; */
        for (let i = 0; i < message.quickbooksOnlineUrls.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.quickbooksOnlineUrls[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ExportJournalEntryToQuickbooksOnlineRes
 */
export const ExportJournalEntryToQuickbooksOnlineRes = new ExportJournalEntryToQuickbooksOnlineRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntryQuickbooksDesktopIIFReq$Type extends MessageType<GetJournalEntryQuickbooksDesktopIIFReq> {
    constructor() {
        super("rd.api.accounting.GetJournalEntryQuickbooksDesktopIIFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntryQuickbooksDesktopIIFReq>): GetJournalEntryQuickbooksDesktopIIFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntryQuickbooksDesktopIIFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntryQuickbooksDesktopIIFReq): GetJournalEntryQuickbooksDesktopIIFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntryQuickbooksDesktopIIFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetJournalEntryQuickbooksDesktopIIFReq
 */
export const GetJournalEntryQuickbooksDesktopIIFReq = new GetJournalEntryQuickbooksDesktopIIFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntryQuickbooksDesktopIIFRes$Type extends MessageType<GetJournalEntryQuickbooksDesktopIIFRes> {
    constructor() {
        super("rd.api.accounting.GetJournalEntryQuickbooksDesktopIIFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntryQuickbooksDesktopIIFRes>): GetJournalEntryQuickbooksDesktopIIFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntryQuickbooksDesktopIIFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntryQuickbooksDesktopIIFRes): GetJournalEntryQuickbooksDesktopIIFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntryQuickbooksDesktopIIFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetJournalEntryQuickbooksDesktopIIFRes
 */
export const GetJournalEntryQuickbooksDesktopIIFRes = new GetJournalEntryQuickbooksDesktopIIFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntrySage100CSVReq$Type extends MessageType<GetJournalEntrySage100CSVReq> {
    constructor() {
        super("rd.api.accounting.GetJournalEntrySage100CSVReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntrySage100CSVReq>): GetJournalEntrySage100CSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntrySage100CSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntrySage100CSVReq): GetJournalEntrySage100CSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntrySage100CSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetJournalEntrySage100CSVReq
 */
export const GetJournalEntrySage100CSVReq = new GetJournalEntrySage100CSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntrySage100CSVRes$Type extends MessageType<GetJournalEntrySage100CSVRes> {
    constructor() {
        super("rd.api.accounting.GetJournalEntrySage100CSVRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntrySage100CSVRes>): GetJournalEntrySage100CSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntrySage100CSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntrySage100CSVRes): GetJournalEntrySage100CSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntrySage100CSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.GetJournalEntrySage100CSVRes
 */
export const GetJournalEntrySage100CSVRes = new GetJournalEntrySage100CSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArchiveJournalEntryReq$Type extends MessageType<ArchiveJournalEntryReq> {
    constructor() {
        super("rd.api.accounting.ArchiveJournalEntryReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ArchiveJournalEntryReq>): ArchiveJournalEntryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ArchiveJournalEntryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArchiveJournalEntryReq): ArchiveJournalEntryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ArchiveJournalEntryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ArchiveJournalEntryReq
 */
export const ArchiveJournalEntryReq = new ArchiveJournalEntryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArchiveJournalEntryRes$Type extends MessageType<ArchiveJournalEntryRes> {
    constructor() {
        super("rd.api.accounting.ArchiveJournalEntryRes", []);
    }
    create(value?: PartialMessage<ArchiveJournalEntryRes>): ArchiveJournalEntryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ArchiveJournalEntryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArchiveJournalEntryRes): ArchiveJournalEntryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ArchiveJournalEntryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.ArchiveJournalEntryRes
 */
export const ArchiveJournalEntryRes = new ArchiveJournalEntryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DownloadJournalEntryCSVReq$Type extends MessageType<DownloadJournalEntryCSVReq> {
    constructor() {
        super("rd.api.accounting.DownloadJournalEntryCSVReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DownloadJournalEntryCSVReq>): DownloadJournalEntryCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DownloadJournalEntryCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DownloadJournalEntryCSVReq): DownloadJournalEntryCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DownloadJournalEntryCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.DownloadJournalEntryCSVReq
 */
export const DownloadJournalEntryCSVReq = new DownloadJournalEntryCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DownloadJournalEntryCSVRes$Type extends MessageType<DownloadJournalEntryCSVRes> {
    constructor() {
        super("rd.api.accounting.DownloadJournalEntryCSVRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<DownloadJournalEntryCSVRes>): DownloadJournalEntryCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<DownloadJournalEntryCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DownloadJournalEntryCSVRes): DownloadJournalEntryCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DownloadJournalEntryCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.accounting.DownloadJournalEntryCSVRes
 */
export const DownloadJournalEntryCSVRes = new DownloadJournalEntryCSVRes$Type();
/**
 * @generated ServiceType for protobuf service rd.api.accounting.AccountingService
 */
export const AccountingService = new ServiceType("rd.api.accounting.AccountingService", [
    { name: "CreateAccount", options: {}, I: CreateAccountReq, O: CreateAccountRes },
    { name: "GetAccount", options: {}, I: GetAccountReq, O: GetAccountRes },
    { name: "ListAccounts", options: {}, I: ListAccountsReq, O: ListAccountsRes },
    { name: "UpdateAccount", options: {}, I: UpdateAccountReq, O: UpdateAccountRes },
    { name: "DeactivateAccount", options: {}, I: DeactivateAccountReq, O: DeactivateAccountRes },
    { name: "ReactivateAccount", options: {}, I: ReactivateAccountReq, O: ReactivateAccountRes },
    { name: "BulkUpsertAccounts", options: {}, I: BulkUpsertAccountsReq, O: BulkUpsertAccountsRes },
    { name: "ListMappings", options: {}, I: ListMappingsReq, O: ListMappingsRes },
    { name: "UpdateMappingAccount", options: {}, I: UpdateMappingAccountReq, O: UpdateMappingAccountRes },
    { name: "BulkUpsertMappings", options: {}, I: BulkUpsertMappingsReq, O: BulkUpsertMappingsRes },
    { name: "GenerateBalanceSheet", options: {}, I: GenerateBalanceSheetReq, O: GenerateBalanceSheetRes },
    { name: "GenerateIncomeStatement", options: {}, I: GenerateIncomeStatementReq, O: GenerateIncomeStatementRes },
    { name: "GenerateJournalEntries", options: {}, I: GenerateJournalEntriesReq, O: GenerateJournalEntriesRes },
    { name: "GenerateJournalEntriesPDF", options: {}, I: GenerateJournalEntriesPDFReq, O: GenerateJournalEntriesPDFRes },
    { name: "GenerateJournalEntriesIIF", options: {}, I: GenerateJournalEntriesIIFReq, O: GenerateJournalEntriesIIFRes },
    { name: "CreateExternalAccount", options: {}, I: CreateExternalAccountReq, O: CreateExternalAccountRes },
    { name: "UpdateExternalAccount", options: {}, I: UpdateExternalAccountReq, O: UpdateExternalAccountRes },
    { name: "DeactivateExternalAccount", options: {}, I: DeactivateExternalAccountReq, O: DeactivateExternalAccountRes },
    { name: "ListExternalAccounts", options: {}, I: ListExternalAccountsReq, O: ListExternalAccountsRes },
    { name: "GetExternalAccountBalance", options: {}, I: GetExternalAccountBalanceReq, O: GetExternalAccountBalanceRes },
    { name: "CreateExternalTransaction", options: {}, I: CreateExternalTransactionReq, O: CreateExternalTransactionRes },
    { name: "UpdateExternalTransaction", options: {}, I: UpdateExternalTransactionReq, O: UpdateExternalTransactionRes },
    { name: "VoidExternalTransaction", options: {}, I: VoidExternalTransactionReq, O: VoidExternalTransactionRes },
    { name: "GetExternalTransaction", options: {}, I: GetExternalTransactionReq, O: GetExternalTransactionRes },
    { name: "GeneratePayoutReconciliation", options: {}, I: GeneratePayoutReconciliationReq, O: GeneratePayoutReconciliationRes },
    { name: "GenerateGeneralLedger", options: {}, I: GenerateGeneralLedgerReq, O: GenerateGeneralLedgerRes },
    { name: "GenerateGeneralLedgerPDF", options: {}, I: GenerateGeneralLedgerPDFReq, O: GenerateGeneralLedgerPDFRes },
    { name: "GenerateGeneralLedgerCSV", options: {}, I: GenerateGeneralLedgerCSVReq, O: GenerateGeneralLedgerCSVRes },
    { name: "GetJournalEntry", options: {}, I: GetJournalEntryReq, O: GetJournalEntryRes },
    { name: "GenerateJournalEntriesV2", options: {}, I: GenerateJournalEntriesV2Req, O: GenerateJournalEntriesV2Res },
    { name: "GenerateJournalEntryForOrderShipment", options: {}, I: GenerateJournalEntryForOrderShipmentReq, O: GenerateJournalEntryForOrderShipmentRes },
    { name: "ExportJournalEntryToQuickbooksOnline", options: {}, I: ExportJournalEntryToQuickbooksOnlineReq, O: ExportJournalEntryToQuickbooksOnlineRes },
    { name: "GetJournalEntryQuickbooksDesktopIIF", options: {}, I: GetJournalEntryQuickbooksDesktopIIFReq, O: GetJournalEntryQuickbooksDesktopIIFRes },
    { name: "GetJournalEntrySage100CSV", options: {}, I: GetJournalEntrySage100CSVReq, O: GetJournalEntrySage100CSVRes },
    { name: "ArchiveJournalEntry", options: {}, I: ArchiveJournalEntryReq, O: ArchiveJournalEntryRes },
    { name: "DownloadJournalEntryCSV", options: {}, I: DownloadJournalEntryCSVReq, O: DownloadJournalEntryCSVRes }
]);
